<template>
  <div class="p-8 pt-12">
    <TransactionProperty
      :reference="reference"
      @dataAvailable="
        data => {
          transactionData = data || {}
        }
      "
    />
    <div class="flex flex-col gap-4 items-center">
      <div class="text-3xl font-medium title-description-color">
        {{ transactionData?.amountToReceive }}
        {{ transactionData?.currencyToReceive }}
      </div>
      <div
        class="rounded-full glassBg title-description-color font-medium shadow-md p-4 px-6 gap-4 flex items-center"
      >
        <div class="w-6 h-6">
          <img
            v-if="statusImages[transactionData?.status]"
            :src="statusImages[transactionData?.status]"
            alt=""
            class="w-full h-full"
          />
        </div>
        {{ $t('transactions.list.status.' + (transactionData?.status || '')) }}
      </div>
    </div>
    <div class="py-3"></div>
    <div class="flex flex-col gap-8 font-medium">
      <div class="flex justify-between w-full">
        <div class="description-color">Message</div>
        <div class="text-right max-w-[55%] title-description-color">
          {{
            $t(
              'transactions.list.detailedStatus.' +
                (transactionData?.statusCode || ''),
            )
          }}
        </div>
      </div>
      <div class="flex justify-between w-full">
        <div class="description-color">Opération</div>
        <div class="text-right title-description-color">
          {{
            $t(
              'transactions.list.operationName.' +
                (transactionData?.operationName || ''),
            )
          }}
        </div>
      </div>
      <div class="flex justify-between w-full">
        <div class="description-color">Date</div>
        <div class="text-right title-description-color">
          {{ transactionData?.startDate }}
        </div>
      </div>
      <div
        class="flex justify-between w-full"
        v-if="
          transactionData?.metaData?.src?.bookmaker ||
          transactionData?.metaData?.dst?.bookmaker
        "
      >
        <div class="description-color">Bookmaker</div>
        <div class="text-right title-description-color">
          {{
            transactionData?.metaData?.src?.bookmaker ||
            transactionData?.metaData?.dst?.bookmaker ||
            ''
          }}
        </div>
      </div>
      <div
        class="flex justify-between w-full"
        v-if="
          transactionData?.metaData?.src?.playerId ||
          transactionData?.metaData?.dst?.playerId
        "
      >
        <div class="description-color">Id Bookmaker</div>
        <div class="text-right title-description-color">
          {{
            transactionData?.metaData?.src?.playerId ||
            transactionData?.metaData?.dst?.playerId ||
            ''
          }}
        </div>
      </div>
      <div
        class="flex justify-between w-full"
        v-if="
          transactionData?.metaData?.src?.phoneNumber ||
          transactionData?.metaData?.dst?.phoneNumber
        "
      >
        <div class="description-color">Téléphone</div>
        <div class="text-right title-description-color">
          {{
            transactionData?.metaData?.src?.phoneNumber ||
            transactionData?.metaData?.dst?.phoneNumber ||
            ''
          }}
        </div>
      </div>

      <div class="flex justify-between w-full">
        <div class="description-color">Transaction Id</div>
        <div
          class="flex gap-2 items-center"
          @click="
            () => {
              $Commons.copy(reference, 'Identifiant copié')
            }
          "
        >
          <span class="title-description-color">
            {{ reference }}
          </span>
          <div class="w-4 h-4">
            <img
              src="~@/assets/images/all/copy-white.svg"
              alt=""
              class="w-full h-full"
            />
          </div>
        </div>
      </div>

      <div
        class="flex justify-between w-full"
        v-if="
          transactionData?.metaData?.src?.metadata?.card?.name ||
          transactionData?.metaData?.dst?.metadata?.card?.name
        "
      >
        <div class="description-color">Carte</div>
        <div class="text-right title-description-color">
          {{
            transactionData?.metaData?.src?.metadata?.card?.name ||
            transactionData?.metaData?.dst?.metadata?.card?.name
          }}
        </div>
      </div>

      <div
        class="flex justify-between w-full"
        v-if="transactionData?.metaData?.dst?.metadata?.recipientEmail"
      >
        <div class="description-color">Email de réception</div>
        <div class="text-right title-description-color">
          {{ transactionData?.metaData?.dst?.metadata?.recipientEmail }}
        </div>
      </div>
      <div class="py-4"></div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import TransactionProperty from './TransactionProperty.vue'
import pendingIcon from '@/assets/images/all/history-yellow.svg'
import successIcon from '@/assets/images/all/check-green.svg'
import errorIcon from '@/assets/images/all/remove-red.svg'
import rejectedIcon from '@/assets/images/all/remove-red.svg'

export default defineComponent({
  name: 'TransactionDetailsComponent',
  components: { TransactionProperty },
  props: {
    reference: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      statusImages: {
        pending: pendingIcon,
        paidWaiting: pendingIcon,
        paidFailed: pendingIcon,
        success: successIcon,
        error: errorIcon,
        rejected: rejectedIcon,
      },
      transactionData: {},
    }
  },
  mounted() {
  },
  methods: {
    launchChatForTransaction() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Bientot disponible',
        body: 'Le chat avec le caissier sera bientot disponible',
      })
    },
  },
})
</script>
